<template>
  <div id="hresh1x-detail-tab3" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#tab3">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRPM4GEC2']['50'] }}
      </h3>
    </div>
    <div id="tab3" class="panel-collapse collapse tab-detail">
      <div class="panel-body">
        <div class="detail detail-responsive">
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-2 control-label">{{ labels['HRPM4GEC4']['10'] }}</label>
              <div class="col-md-2">
                <div class="form-control readonly-field-color">{{ data.detail.numprdst }}</div>
              </div>
              <label class="col-md-1 control-label">{{ labels['HRPM4GEC4']['20'] }}</label>
              <div class="col-md-2">
                <div class="form-control readonly-field-color">{{ data.detail.dtemthst }}</div>
              </div>
              <label class="col-md-1 control-label">{{ labels['HRPM4GEC4']['30'] }}</label>
              <div class="col-md-2">
                <div class="form-control readonly-field-color">{{ setYearOutput(data.detail.dteyearst) }}</div>
              </div>
            </div>
          </form>

          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-2 control-label">{{ labels['HRPM4GEC4']['40'] }}</label>
              <div class="col-md-2">
                <div class="form-control readonly-field-color">{{ data.detail.numprden }}</div>
              </div>
              <label class="col-md-1 control-label">{{ labels['HRPM4GEC4']['50'] }}</label>
              <div class="col-md-2">
                <div class="form-control readonly-field-color">{{ data.detail.dtemthen }}</div>
              </div>
              <label class="col-md-1 control-label">{{ labels['HRPM4GEC4']['60'] }}</label>
              <div class="col-md-2">
                <div class="form-control readonly-field-color">{{ setYearOutput(data.detail.dteyearen) }}</div>
              </div>
            </div>
          </form>

          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-2 control-label">{{ labels['HRPM4GEC4']['70'] }}</label>
              <div class="col-md-5">
                <div class="form-control readonly-field-color">{{ data.detail.codpay }} - {{ data.detail.desc_codpay }}</div>
              </div>
            </div>
          </form>

          <div class="col-md-12">
            <div class="col-md-7 clearfix">
              <hrms-table :columns="tab3Table" :data="data.table" :indexDisp="false"  />
            </div>
            <div class="col-md-5 clearfix">
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRPM4GEC4']['140'] }}</label>
                  <div class="col-md-6">
                    <div class="input-group">
                      <input type="text" disabled="disabled" class="form-control input-text" v-model="amtded">
                      <div class="input-group-addon input-group-addon-cust ">{{ labels['HRPM4GEC4']['150'] }}</div>
                    </div>
                  </div>
                </div>

                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRPM4GEC4']['160'] }}</label>
                  <div class="col-md-6">
                    <div class="input-group">
                      <input type="text" disabled="disabled" class="form-control input-text" v-model="amttotded">
                      <div class="input-group-addon input-group-addon-cust ">{{ labels['HRPM4GEC4']['170'] }}</div>
                    </div>
                  </div>
                </div>
              </form>

            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hresh1x-detail-tab3',
  props: [ 'labels', 'data', 'tab3Table' ],
  data () {
    return {
      amtded: '',
      amttotded: ''
    }
  },
  watch: {
    data () {
      this.amtded = ''
      this.amttotded = ''
      if (this.data.table.total > 0) {
        if (typeof this.data.table.rows[0] !== 'undefined') {
          if (typeof this.data.table.rows[0].amtded !== 'undefined') {
            this.amtded = this.data.table.rows[0].amtded
          }
          if (typeof this.data.table.rows[0].amttotded !== 'undefined') {
            this.amttotded = this.data.table.rows[0].amttotded
          }
        }
      }
    }
  },
  methods: {
    setYearOutput (date) {
      return assetsUtils.getYearOutput(date)
    }
  }
}
</script>


// WEBPACK FOOTER //
// detailTab3.vue?1ed9056c